export default {
  'home.metaTitle': 'USFans Spreadsheet 2026 – Znaleziska, Recenzje, QC i Poradnik Zakupowy',
  'home.metaDescription':
    'Poznaj USFans Spreadsheet: znaleziska produktów, poradniki QC, informacje o wysyłce, recenzje, wskazówki bezpieczeństwa, kupony i praktyczne zasoby zakupowe na 2026 rok.',

  'home.navHome': 'Strona główna',
  'home.navSpreadsheet': 'Spreadsheet',
  'home.navCategories': 'Kategorie',
  'home.navGuides': 'Poradniki',
  'home.navShoppingGuide': 'Poradnik zakupów',
  'home.navReviews': 'Recenzje',
  'home.navShipping': 'Wysyłka',
  'home.navSafety': 'Bezpieczeństwo',
  'home.navVisit': 'Odwiedź główną stronę',

  'home.heroBadge': 'Centrum zasobów USFans Spreadsheet',
  'home.heroTitle': 'Znajdź lepsze produkty dzięki USFans Spreadsheet',
  'home.heroSubtitle':
    'USFans Spreadsheet ułatwia badanie produktów, porządkując przydatne znaleziska, kategorie, zasoby QC, poradniki wysyłkowe, recenzje i informacje zakupowe w jednym przeszukiwalnym miejscu.',
  'home.heroSubtitle2':
    'Niezależnie od tego, czy dopiero zaczynasz z USFans, czy znasz już cały proces, zacznij tutaj, aby zbadać produkty, porównać opcje i zrozumieć proces zakupowy przed podjęciem decyzji.',
  'home.heroTrust': 'Niezależne źródło informacji • Regularnie aktualizowane • Przyjazne dla początkujących',
  'home.ctaSpreadsheet': 'usfans spreadsheet',
  'home.ctaBuyNow': 'kup teraz',
  'home.ctaGuide': 'Przeczytaj poradnik dla początkujących',

  'home.catTitle': 'Przeglądaj kategorie USFans Spreadsheet',
  'home.catSubtitle':
    'Przeglądaj uporządkowane kategorie i przejdź bezpośrednio do produktów, których szukasz, na głównej stronie.',
  'home.catPlaceholder': 'Wybierz kategorię',
  'home.catBrowseAll': 'Przeglądaj wszystkie kategorie',
  'home.catShoes': 'Buty',
  'home.catHoodies': 'Bluzy / Swetry',
  'home.catTshirts': 'Koszulki',
  'home.catJackets': 'Kurtki',
  'home.catPants': 'Spodnie / Szorty',
  'home.catHeadwear': 'Nakrycia głowy',
  'home.catSets': 'Zestawy',
  'home.catUnderwear': 'Bielizna',
  'home.catJersey': 'Koszulki sportowe',
  'home.catAccessories': 'Akcesoria',
  'home.catBags': 'Torby',
  'home.catBelts': 'Paski',
  'home.catPerfumes': 'Perfumy',
  'home.catOther': 'Inne rzeczy',

  'home.whatTitle': 'Czym jest USFans Spreadsheet?',
  'home.whatP1':
    'USFans Spreadsheet to uporządkowane źródło do odkrywania i badania linków produktów, kategorii i informacji zakupowych powiązanych z USFans.',
  'home.whatP2':
    'Zamiast szukać po rozproszonych postach, możesz przeglądać uporządkowane kategorie, poradniki, recenzje, informacje QC, zasoby wysyłkowe i najczęściej zadawane pytania w jednym miejscu.',
  'home.whatCta': 'Przeglądaj Spreadsheet',

  'home.whyTitle': 'Dlaczego warto korzystać z USFans Spreadsheet?',
  'home.whySubtitle': 'Kilka powodów, dla których spreadsheet pomaga robić zakupy efektywniej.',
  'home.why1Title': 'Badaj szybciej',
  'home.why1Desc': 'Znajduj odpowiednie produkty i zasoby bez przeszukiwania dziesiątek niepowiązanych stron.',
  'home.why2Title': 'Porównuj opcje',
  'home.why2Desc': 'Korzystaj z uporządkowanych informacji i tabel porównawczych przed podjęciem decyzji.',
  'home.why3Title': 'Zrozum QC',
  'home.why3Desc': 'Dowiedz się, co oznaczają zdjęcia QC i co sprawdzić przed wysyłką.',
  'home.why4Title': 'Zrozum wysyłkę',
  'home.why4Desc': 'Dowiedz się, jak waga, miejsce docelowe, opakowanie i metody wysyłki wpływają na całkowite koszty.',

  'home.reviewTitle': 'Recenzja USFans',
  'home.reviewP':
    'Zastanawiasz się nad skorzystaniem z USFans? Przeczytaj naszą niezależną recenzję USFans obejmującą działanie procesu, zalety, ograniczenia, QC, magazyn, wysyłkę, bezpieczeństwo i typowe problemy.',
  'home.review1': 'Jak działa proces',
  'home.review2': 'Zalety i ograniczenia',
  'home.review3': 'QC i magazyn',
  'home.review4': 'Wysyłka',
  'home.review5': 'Bezpieczeństwo i kwestie użytkownika',
  'home.review6': 'Typowe problemy',
  'home.reviewCta': 'Przeczytaj recenzję USFans',

  'home.shipTitle': 'Koszt wysyłki USFans',
  'home.shipP':
    'Wysyłka może znacząco wpłynąć na końcowy koszt zamówienia. Dowiedz się, jak koszt wysyłki może się różnić w zależności od różnych czynników.',
  'home.ship1': 'Miejsce docelowe',
  'home.ship2': 'Waga i objętość paczki',
  'home.ship3': 'Linia wysyłkowa i opakowanie',
  'home.ship4': 'Ubezpieczenie i zmiany sezonowe',
  'home.shipNote': 'Ceny się różnią — sprawdź aktualne stawki i oszacuj przed zakupem.',
  'home.shipCta': 'Zobacz poradnik kosztów wysyłki',

  'home.couponTitle': 'Kupon i kod rabatowy USFans',
  'home.couponP':
    'Dedykowane źródło kuponów USFans, kodów rabatowych, kodów promocyjnych i kuponów wysyłkowych. Każda strona kuponu pokazuje status, datę sprawdzenia, wygaśnięcie, ograniczenia i sposób użycia.',
  'home.coupon1': 'Status i data sprawdzenia',
  'home.coupon2': 'Wygaśnięcie i ograniczenia',
  'home.coupon3': 'Źródło',
  'home.coupon4': 'Jak zastosować',
  'home.couponNote': 'Nie znaleziono zweryfikowanego aktywnego kodu.',
  'home.couponCta': 'Sprawdź aktualne kupony',

  'home.wareTitle': 'Magazyn USFans',
  'home.wareP':
    'Zrozum, czym zajmuje się magazyn: zdjęcia QC, przechowywanie, konsolidacja paczek, pakowanie, przygotowanie do wysyłki, kontrola i potencjalne limity przechowywania.',
  'home.ware1': 'Zdjęcia QC i kontrola',
  'home.ware2': 'Przechowywanie',
  'home.ware3': 'Konsolidacja paczek',
  'home.ware4': 'Pakowanie i przygotowanie do wysyłki',
  'home.ware5': 'Potencjalne limity przechowywania',
  'home.wareCta': 'Przeczytaj poradnik o magazynie',

  'home.legitTitle': 'Czy USFans jest legalne?',
  'home.legitP':
    'Uzyskaj bezpośrednią odpowiedź na intencję wyszukiwania. Zrozum, czym jest USFans, jak działa proces zakupowy oraz jakie ryzyka i kontrole warto znać przed płatnością.',
  'home.legit1': 'Czym USFans jest (a czym nie jest)',
  'home.legit2': 'Jak działa proces zakupowy',
  'home.legit3': 'Jakie ryzyka zrozumieć',
  'home.legit4': 'Jak weryfikować informacje',
  'home.legit5': 'Co sprawdzić przed płatnością',
  'home.legitNote': 'Bez niepopartych twierdzeń — przeczytaj fakty zanim zdecydujesz.',
  'home.legitCta': 'Przeczytaj poradnik o legalności',

  'home.compTitle': 'Porównanie USFans Spreadsheet',
  'home.compHeader1': 'Zasób',
  'home.compHeader2': 'Główny cel',
  'home.compHeader3': 'Najlepszy do',
  'home.compHeader4': 'Informacje QC',
  'home.compHeader5': 'Informacje wysyłkowe',
  'home.compHeader6': 'Przyjazne dla początkujących',
  'home.compRow1c1': 'Spreadsheet',
  'home.compRow1c2': 'Badanie produktów',
  'home.compRow1c3': 'Znajdowanie produktów',
  'home.compRow1c4': 'Różnie',
  'home.compRow1c5': 'Poradnik',
  'home.compRow1c6': 'Tak',
  'home.compRow2c1': 'Recenzja',
  'home.compRow2c2': 'Badanie platformy',
  'home.compRow2c3': 'Ocena',
  'home.compRow2c4': 'Tak',
  'home.compRow2c5': 'Tak',
  'home.compRow2c6': 'Tak',
  'home.compRow3c1': 'Poradnik QC',
  'home.compRow3c2': 'Badanie jakości',
  'home.compRow3c3': 'QC',
  'home.compRow3c4': 'Tak',
  'home.compRow3c5': 'Ograniczone',
  'home.compRow3c6': 'Tak',
  'home.compRow4c1': 'Poradnik wysyłki',
  'home.compRow4c2': 'Badanie dostawy',
  'home.compRow4c3': 'Wysyłka',
  'home.compRow4c4': 'Nie',
  'home.compRow4c5': 'Tak',
  'home.compRow4c6': 'Tak',

  'home.guidesTitle': 'Najnowsze poradniki USFans',
  'home.guidesSubtitle': 'Świeże, oryginalne poradniki, które pomogą Ci badać i kupować z pewnością.',
  'home.guidesRead': 'Przeczytaj artykuł',
  'home.guidesUpdated': 'Zaktualizowano',

  'home.faqTitle': 'Najczęściej zadawane pytania',
  'home.faqQ1': 'Czym jest USFans Spreadsheet?',
  'home.faqA1':
    'To uporządkowane źródło, które łączy linki produktów, kategorie i informacje zakupowe w jednym przeszukiwalnym miejscu do badania produktów.',
  'home.faqQ2': 'Czy USFans jest legalne?',
  'home.faqA2':
    'USFans to proces badawczo-zakupowy. Zawsze weryfikuj linki, sprawdzaj informacje o sprzedawcy i rozumiej ryzyka przed dokonaniem płatności.',
  'home.faqQ3': 'Ile kosztuje wysyłka USFans?',
  'home.faqA3':
    'Wysyłka różni się w zależności od miejsca docelowego, wagi, objętości, linii, opakowania i sezonu. Sprawdź aktualne stawki przed zakupem.',
  'home.faqQ4': 'Czy są aktywne kody kuponów USFans?',
  'home.faqA4':
    'Kody często się zmieniają. Jeśli nie ma zweryfikowanego aktywnego kodu, traktuj regularną cenę jako punkt odniesienia.',
  'home.faqQ5': 'Co sprawdzić przed zakupem?',
  'home.faqA5':
    'Przejrzyj zdjęcia QC, oszacuj wysyłkę, potwierdź dane sprzedawcy, sprawdź zasady zwrotów i zachowaj zapisy zamówienia.',

  'home.finalTitle': 'Gotowy, aby zacząć?',
  'home.finalSubtitle':
    'Zacznij od USFans Spreadsheet, a następnie skorzystaj z naszych poradników, aby badać produkty, zrozumieć QC i porównać opcje wysyłki.',
  'home.finalCta': 'Przeglądaj USFans Spreadsheet',

  'home.footerDesc':
    'Niezależne źródło informacji o USFans Spreadsheet. Niepowiązane z USFans ani nie wspierane przez USFans, chyba że wyraźnie zaznaczono.',
  'home.footerResources': 'Zasoby',
  'home.footerSpreadsheet': 'USFans Spreadsheet',
  'home.footerGuides': 'Poradniki',
  'home.footerReviews': 'Recenzje',
  'home.footerShipping': 'Wysyłka',
  'home.footerCoupons': 'Kupony',
  'home.footerWarehouse': 'Magazyn',
  'home.footerQC': 'QC',
  'home.footerSafety': 'Bezpieczeństwo',
  'home.footerFaq': 'FAQ',
  'home.footerCompany': 'Firma',
  'home.footerAbout': 'O nas',
  'home.footerContact': 'Kontakt',
  'home.footerEditorial': 'Polityka redakcyjna',
  'home.footerPrivacy': 'Polityka prywatności',
  'home.footerTerms': 'Regulamin',
  'home.footerDisclaimer': 'Zastrzeżenie',
  'home.footerLanguages': 'Języki',
  'home.footerRights': 'Wszelkie prawa zastrzeżone.',
};